<template>
    <div class="dia_container">
        <el-tabs v-model="editTab">
            <el-tab-pane label="企业信息" name="first">
                <div class="base_info">
                    <h3 class="title">企业信息：</h3>
                    <div class="info_content cl">
                        <div class="info_line l">
                            <label class="l">企业名称<span class="red">*</span>：</label>
                            <div class="l inpt"><el-input v-model="config.tenantname"></el-input></div>
                        </div>
                        <div class="info_line l">
                            <label class="l">企业id<span class="red">*</span>：</label>
                            <div class="l inpt">
                                <el-input :class="{genCode:!edit}" :disabled="edit" v-model="config.tenantcode"></el-input>
                                <el-button v-if="!edit" type="text" @click="genCode">生成ID</el-button>
                            </div>
                        </div>
                        <div class="info_line l">
                            <label class="l">企业简称：</label>
                            <div class="l inpt"><el-input v-model="config.tenantshortname"></el-input></div>
                        </div>
                        <div class="info_line l">
                            <label class="l">人员规模<span class="red">*</span>：</label>
                            <div class="l sel">
                                <el-select v-model="config.personnelscale">
                                    <el-option v-for="item in optionsPersonnelScale" :label="item.dicvalue" :value="item.dictionaryid"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="info_line l">
                            <label class="l">实施级别<span class="red">*</span>：</label>
                            <div class="l sel">
                                <el-select v-model="config.implementlevel">
                                    <el-option v-if="implementlevel == '0'" label="产品开发" :value="0"></el-option>
                                    <el-option v-if="implementlevel != '0'" label="标准产品" :value="1"></el-option>
                                    <el-option v-if="implementlevel != '0'" label="标准配置" :value="2"></el-option>
                                    <el-option v-if="implementlevel != '0'" label="实施级配置" :value="3"></el-option>
                                    <el-option v-if="implementlevel != '0'" label="代码级修改" :value="4"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="info_line l">
                            <label class="l">资源等级<span class="red">*</span>：</label>
                            <div class="l sel">
                                <el-select v-model="config.sourcetype">
                                    <el-option v-for="item in optionsSourceType" :label="item.dicvalue" :value="item.dictionaryid"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="info_line l">
                            <label class="l">租户类型<span class="red">*</span>：</label>
                            <div class="l sel">
                                <el-select v-model="config.tenanttype">
                                    <el-option label="战略客户" :value="1"></el-option>
                                    <el-option label="核心客户" :value="2"></el-option>
                                    <el-option label="价值客户" :value="3"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="info_line l">
                            <label class="l">所属行业<span class="red">*</span>：</label>
                            <div class="l sel">
                                <el-select v-model="config.industry">
                                    <el-option v-for="item in optionsIndustry" :label="item.industryname" :value="item.industrycode"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="info_line l">
                            <label class="l">企业联系人<span class="red">*</span>：</label>
                            <div class="l inpt"><el-input v-model="config.contact"></el-input></div>
                        </div>
                        <div class="info_line l">
                            <label class="l">联系人手机号<span class="red">*</span>：</label>
                            <div class="l inpt"><el-input v-model="config.mobile"></el-input></div>
                        </div>
                        <div class="info_line l">
                            <label class="l">联系邮箱<span class="red">*</span>：</label>
                            <div class="l inpt"><el-input v-model="config.email"></el-input></div>
                        </div>
                        <div class="info_line l">
                            <label class="l">公司座机<span class="red">*</span>：</label>
                            <div class="l inpt"><el-input v-model="config.telephone"></el-input></div>
                        </div>
                        <div class="info_line l">
                            <label class="l">开通用途<span class="red">*</span>：</label>
                            <div class="l sel">
                                <el-select v-model="config.tenantapplytype">
                                    <el-option v-for="item in optionsApplyType" :label="item.dicvalue" :value="item.dictionaryid"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="info_line l">
                            <label class="l">有效截止日期<span v-if="config.tenantapplytype == '1'" class="red">*</span>：</label>
                            <div class="l sel">
                                <el-date-picker
                                        style="width:100%;"
                                        v-model="config.expiredtime"
                                        type="date"
                                        :picker-options="pickerOptions"
                                        placeholder="选择日期">
                                </el-date-picker>
                            </div>
                        </div>
                        <div class="info_line w100p l">
                            <label class="l">企业地址：</label>
                            <div class="l inpt"><el-input v-model="config.address"></el-input></div>
                        </div>
                        <div class="info_line w100p l">
                            <label class="l">企业介绍：</label>
                            <div class="l textarea"><el-input v-model="config.tenantdescr" type="textarea"></el-input></div>
                        </div>
                    </div>
                </div>
                <div class="dia_btn_container">
                    <el-button @click="cancel">取消</el-button>
                    <el-button type="primary" @click="saveCompanyInfo">保存</el-button>
                </div>
            </el-tab-pane>
            <el-tab-pane label="应用模块" :disabled="!edit" name="second">
                <div class="cl app_model_container">
                    <div class="l mode_list">
                        <div v-for="item in options.productSeries" class="item" @click="switchSeries(item)" :class="{current: item.productseriescode === curSerie}">{{item.productseriesname}}<i class="fa fa-angle-right"></i></div>
                    </div>
                    <div class="l mode_list">
                        <div class="item" v-for="item in options.products" @click="switchProducts(item)" :class="{current: item.productcode === curProduct}">{{item.productname}}<i class="fa fa-angle-right"></i></div>
                    </div>
                    <div class="l mode_list">
                        <div class="item" v-for="item in options.productVersions" @click="switchVersions(item)" :class="{current: item.productversioncode === curVersion}">{{item.productversionname}}<i class="fa fa-angle-right"></i></div>
                    </div>
                    <div class="l mode_list">
                        <el-radio-group v-model="curPackage">
                            <el-radio v-for="(item, idx) in options.productPackages" :key="idx" :label="item.productpackagecode">{{item.productpackagename}}</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="dia_btn_container">
                    <el-button @click="cancel">取消</el-button>
                    <el-button type="primary" @click="saveAppModel">保存</el-button>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    import { errorMessage, dateFormat } from '../../../util'
    export default {
        props: ['param', 'optionsIndustry', 'optionsPersonnelScale', 'optionsSourceType', 'optionsApplyType', 'implementlevel'],
        data() {
            return {
                options: {
                    productSeries: [],
                    products: [],
                    productVersions: [],
                    productPackages: []
                },
                curSerie: '',
                curProduct: '',
                curVersion: '',
                curPackage: '',
                config: {
                    tenantname: '',
                    tenantcode: '',
                    tenantshortname: '',
                    personnelscale: '',
                    implementlevel: '',
                    sourcetype: '',
                    tenanttype: '',
                    industry: '',
                    contact: '',
                    mobile: '',
                    email: '',
                    telephone: '',
                    tenantapplytype: '',
                    expiredtime: '',
                    address: '',
                    tenantdescr: ''
                },
                editTab: 'first',
                edit: true,
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                }
            }
        },
        created() {
            this.init()
        },
        methods: {
            init() {
                let data = this.param.data
                this.editTab = this.param.editTab
                this.edit = this.param.edit
                this.setConfigData(data)
                this.initAppModelData(() => {
                    if(data.productversioncode) {
                        this.getProductPackages(data.productversioncode).then(res => {
                            this.options.productPackages = res.data.resp_data
                            this.setAppModelData(data)
                        }).catch(error => {
                            errorMessage(error, this)
                        })
                    }
                })
            },
            // 初始化应用模块信息
            initAppModelData(callBack) {
                this.$http.post(`/platserv/productSeries/getProductSeries`, {}).then(res => {
                    let data = res.data.resp_data
                    this.options.productSeries = data
                    this.options.products = data[0].products
                    this.options.productVersions = data[0].products[0].productversions
                    if (typeof callBack === 'function') callBack()
                }).catch(error => {
                    errorMessage(error, this)
                })
            },
            // 产品选择
            switchSeries(item) {
                this.curSerie = item.productseriescode
                this.options.products = item.products
                this.options.productVersions = []
                this.options.productPackages = []
                this.curProduct = ''
                this.curVersion = ''
                this.curPackage = ''
            },
            switchProducts(item) {
                this.options.productVersions = item.productversions
                this.curProduct = item.productcode
                this.curVersion = ''
                this.curPackage = ''
            },
            switchVersions(item) {
                this.curVersion = item.productversioncode
                this.curPackage = ''
                this.getProductPackages(item.productversioncode).then(res => {
                    this.options.productPackages = res.data.resp_data
                }).catch(error => {
                    errorMessage(error, this)
                })
            },
            // 设置编辑信息
            setConfigData(data = {}) {
                for (let i in this.config) {
                    if (i !== 'expiredtime') {
                        this.config[i] = data[i] + '' ? data[i] : ''
                    } else {
                        this.config[i] = data[i] ? data[i].split(' ')[0] : ''
                    }
                }
            },
            // 设置应用模块信息
            setAppModelData(data = {}) {
                let _this = this
                this.curSerie = data.productseriescode ? data.productseriescode : ''
                this.curProduct = data.productcode ? data.productcode : ''
                this.curVersion = data.productversioncode ? data.productversioncode : ''
                this.curPackage = data.productpackagecode ? data.productpackagecode : ''
                if(this.curSerie){
                    this.options.productSeries.forEach(function(item){
                        if(item.productseriescode === _this.curSerie){
                            _this.options.products = item.products
                        }
                    })
                }
                if(this.curProduct){
                    this.options.products.forEach(function(item){
                        if(item.productcode === _this.curProduct){
                            _this.options.productVersions = item.productversions
                        }
                    })
                }
            },
            // 保存企业信息
            saveCompanyInfo() {
                let checkResult = ''
                let param = {}
                let config = this.config
                let expiredtime = config.expiredtime ? dateFormat('y-m-d', new Date(config.expiredtime).getTime()) + ' 23:59:59' : ''
                let tenantapplytype = config.tenantapplytype ? parseInt(config.tenantapplytype) : ''
                for(let i in config) {
                    param[i] = config[i]
                }
                param.expiredtime = expiredtime
                param.tenantapplytype = tenantapplytype
                checkResult = this.checkCompanyInfo(param)
                if(!checkResult){
                    let url = this.edit ? `/platserv/tenant/update` : `/platserv/tenant/add`
                    this.$http.post(url, param).then(res => {
                        this.$message.success('保存成功！')
                        this.$emit('reload')
                        if(!this.edit) {
                            this.edit = true
                        }
                    }).catch(error => {
                        errorMessage(error, this)
                    })
                }else {
                    this.$message.warning(checkResult)
                }
            },
            // 保存应用模块
            saveAppModel() {
                let checkResult = ''
                let param = {
                    productcode: this.curProduct,
                    productversioncode: this.curVersion,
                    productseriescode: this.curSerie,
                    tenantcode: this.config.tenantcode,
                    productpackagecode: this.curPackage
                }
                checkResult = this.checkAppModelInfo(param)
                if (checkResult) {
                    this.$message.warning(checkResult)
                    return
                }
                this.$http.post(`/platserv/tenant/saveModuleConfig`, param).then(function(res){
                    this.$message.success('保存成功！')
                    this.$emit('reload')
                }).catch(error => {
                    errorMessage(error, this)
                })
            },
            cancel() {
                this.$emit('cancel')
            },
            // 自动生成ID
            genCode() {
                let _this = this
                _this.$http.post('/platserv/tenant/genCode').then(res => {
                    if (res.data.resp_data) {
                        _this.config.tenantcode = res.data.resp_data
                    } else {
                        _this.$message.error('获取ID失败！')
                    }
                }).catch(error => {
                    errorMessage(error, _this)
                })
            },
            // 加载产品包列表
            getProductPackages(code) {
                return this.$http.post(`/platserv/productPackage/getProductPackages`, {productversioncode: code})
            },
            // 校验企业信息
            checkCompanyInfo(data) {
                let ret = ''
                if(!data.tenantname){
                    ret = '请填写企业名称！'
                }else if(!data.tenantcode){
                    ret = '请填写企业名称！'
                }else if(!this.numberOnly(data.tenantcode)){
                    ret = '企业id只能包含数字！'
                }else if(!data.implementlevel && data.implementlevel != 0){
                    ret = '请选择实施级别！'
                }else if(!data.personnelscale){
                    ret = '请选择人员规模！'
                }else if(!data.tenanttype){
                    ret = '请选择租户类型！'
                }else if(!data.industry){
                    ret = '请选择所属行业！'
                }else if(!data.sourcetype){
                    ret = '请选择资源等级！'
                }else if(!data.contact){
                    ret = '请填写企业联系人！'
                }else if(!data.mobile){
                    ret = '请填写联系人手机号！'
                }else if(!data.telephone){
                    ret = '请填写公司座机！'
                }else if(!data.email){
                    ret = '请填写联系邮箱！'
                }else if(!data.tenantapplytype){
                    ret = '请填写开通用途！'
                }else if(data.tenantapplytype == '1' && !data.expiredtime){
                    ret = '请填写有效截止日期！'
                }
                return ret
            },
            checkAppModelInfo(data) {
                let ret = ''
                if (!data.productversioncode) {
                    ret = '请选择产品版本！'
                }
                if (!data.productcode) {
                    ret = '请选择产品！'
                }
                if (!data.productseriescode) {
                    ret = '请选择产品系列！'
                }
                if (!data.productpackagecode) {
                    ret = '请选择产品包！'
                }
                return ret
            },
            numberOnly(str) {
                let reg = /^[0-9]+$/
                return reg.test(str)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Edit.vue?2bb0a652